import ReactGA from "react-ga4";

const MEASUREMENT_ID = "G-86GVBFWL0V"; // replace with your GA4 ID

export const initGA = () => {
  ReactGA.initialize(MEASUREMENT_ID);
};

export const trackPageview = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
